var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.5625H11.25C11.1425 11.5625 11.0437 11.5888 10.9375 11.5938V8.75C10.9375 6.51 12.76 4.6875 15 4.6875C16.8862 4.6875 18.645 5.99751 19.0913 7.73376C19.2213 8.23501 19.73 8.53624 20.2338 8.40874C20.735 8.27874 21.0375 7.76874 20.9087 7.26624C20.245 4.68624 17.76 2.8125 15 2.8125C11.7263 2.8125 9.0625 5.47625 9.0625 8.75V11.9925C6.87 12.8662 5.3125 15 5.3125 17.5V21.25C5.3125 24.5238 7.97625 27.1875 11.25 27.1875H18.75C22.0238 27.1875 24.6875 24.5238 24.6875 21.25V17.5C24.6875 14.2263 22.0238 11.5625 18.75 11.5625ZM22.8125 21.25C22.8125 23.49 20.99 25.3125 18.75 25.3125H11.25C9.01 25.3125 7.1875 23.49 7.1875 21.25V17.5C7.1875 15.26 9.01 13.4375 11.25 13.4375H18.75C20.99 13.4375 22.8125 15.26 22.8125 17.5V21.25ZM15.9375 18.75V20C15.9375 20.5175 15.5175 20.9375 15 20.9375C14.4825 20.9375 14.0625 20.5175 14.0625 20V18.75C14.0625 18.2325 14.4825 17.8125 15 17.8125C15.5175 17.8125 15.9375 18.2325 15.9375 18.75Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1a7318c4.svg";
export { ForwardRef as ReactComponent };